import { FORTA_WHITE } from '../../utils/colors';

import type { IconProps } from './types';

function TimeTagEndIcon(props: IconProps) {
  const { color = FORTA_WHITE, width = 18, height = 23, viewBox = '0 0 18 23' } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 14.5C1 14.5 2 13.5 5 13.5C8 13.5 10 15.5 13 15.5C16 15.5 17 14.5 17 14.5V3.5C17 3.5 16 4.5 13 4.5C10 4.5 8 2.5 5 2.5C2 2.5 1 3.5 1 3.5M1 21.5L1 1.5"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect x="3" y="4.5" width="2" height="2" rx="0.3" fill={color} />
      <rect x="1" y="2.5" width="2" height="2" rx="0.3" fill={color} />
      <rect x="3" y="8.5" width="2" height="2" rx="0.3" fill={color} />
      <rect x="5" y="6.5" width="2" height="2" rx="0.3" fill={color} />
      <rect x="5" y="2.5" width="2" height="2" rx="0.3" fill={color} />
      <rect x="1" y="6.5" width="2" height="2" rx="0.3" fill={color} />
      <rect x="7" y="8.5" width="2" height="2" rx="0.3" fill={color} />
      <rect x="5" y="10.5" width="2" height="2" rx="0.3" fill={color} />
      <rect x="1" y="10.5" width="2" height="2" rx="0.3" fill={color} />
      <rect x="9" y="6.5" width="2" height="2" rx="0.3" fill={color} />
      <rect x="11" y="8.5" width="2" height="2" rx="0.3" fill={color} />
      <rect x="15" y="8.5" width="2" height="2" rx="0.3" fill={color} />
      <rect x="11" y="4.5" width="2" height="2" rx="0.3" fill={color} />
      <rect x="11" y="12.5" width="2" height="2" rx="0.3" fill={color} />
      <rect x="13" y="10.5" width="2" height="2" rx="0.3" fill={color} />
      <rect x="15" y="12.5" width="2" height="2" rx="0.3" fill={color} />
      <rect x="13" y="6.5" width="2" height="2" rx="0.3" fill={color} />
      <rect x="15" y="4.5" width="2" height="2" rx="0.3" fill={color} />
      <rect x="7" y="4.5" width="2" height="2" rx="0.3" fill={color} />
      <rect x="9" y="10.5" width="2" height="2" rx="0.3" fill={color} />
    </svg>
  );
}

export default TimeTagEndIcon;
